export const QwImageUploaderModeEnum = Object.freeze({
	EMPTY: 'EMPTY',
	PREVIEW: 'PREVIEW',
	UPLOADING: 'UPLOADING',
	SOURCE_PICKER: 'SOURCE_PICKER',
})
